import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import types from './types';

const actions = {
  async getSmsTemplates({ commit }, payload) {
    try {
      commit(types.GET_SMS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.smsTemplates,
        params: payload,
        isToken: true,
      });
      commit(types.GET_SMS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_SMS_FAILURE, message);
    }
  },
  async addOrChangeSmsTemplate({ dispatch, commit }, payload) {
    try {
      commit(types.SMS_START);
      const {
        isNew,
        data,
        id,
        params,
      } = payload;
      await apiCall({
        type: isNew ? 'POST' : 'PUT',
        url: isNew ? URLS.smsTemplates : `${URLS.smsTemplates}/${id}`,
        body: data,
        isToken: true,
      });
      dispatch('getSmsTemplates', params);
      commit(types.SMS_SUCCESS);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.SMS_FAILURE, message);
    }
  },
  async deleteSmsTemplate({ dispatch, commit }, payload) {
    try {
      commit(types.SMS_START);
      const {
        id,
        params,
      } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.smsTemplates}/${id}`,
        isToken: true,
      });
      dispatch('getSmsTemplates', params);
      commit(types.SMS_SUCCESS);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.SMS_FAILURE, message);
    }
  },
  async getMessagesTemplates({ commit }, payload) {
    try {
      commit(types.GET_MESSAGES_TEMPLATES_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.messagesTemplates,
        params: payload,
        isToken: true,
      });
      commit(types.GET_MESSAGES_TEMPLATES_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_MESSAGES_TEMPLATES_FAILURE, message);
    }
  },
  async addMessagesTemplate({ dispatch, commit }, payload) {
    const {
      body,
      params,
    } = payload;
    try {
      commit(types.ADD_MESSAGES_START);
      await apiCall({
        type: 'POST',
        url: URLS.messagesTemplates,
        body,
        isToken: true,
      });
      dispatch('getMessagesTemplates', params);
      commit(types.ADD_MESSAGES_SUCCESS);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.ADD_MESSAGES_FAILURE, message);
    }
  },
  async editMessagesTemplate({ dispatch, commit }, payload) {
    const {
      body,
      id,
      params,
    } = payload;
    try {
      commit(types.EDIT_MESSAGES_START);
      await apiCall({
        type: 'POST',
        url: `${URLS.messagesTemplates}/${id}`,
        body,
        isToken: true,
      });
      dispatch('getMessagesTemplates', params);
      commit(types.EDIT_MESSAGES_SUCCESS);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.EDIT_MESSAGES_FAILURE, message);
    }
  },
  async deleteMessagesTemplate({ dispatch, commit }, payload) {
    try {
      commit(types.SMS_START);
      const {
        id,
        params,
      } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.messagesTemplates}/${id}`,
        isToken: true,
      });
      dispatch('getMessagesTemplates', params);
      commit(types.SMS_SUCCESS);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.SMS_FAILURE, message);
    }
  },
};
export default actions;
